/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VipDiscountDto } from '../../models/vip-discount-dto';

export interface TriggerDefaultVipDiscounts$Params {
}

export function triggerDefaultVipDiscounts(http: HttpClient, rootUrl: string, params?: TriggerDefaultVipDiscounts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VipDiscountDto>>> {
  const rb = new RequestBuilder(rootUrl, triggerDefaultVipDiscounts.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VipDiscountDto>>;
    })
  );
}

triggerDefaultVipDiscounts.PATH = '/discounts/vip/defaults/trigger';
